import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalMailSettingsRoute: InvariantJiraRoute = {
	name: 'global-mail-settings',
	path: '/secure/admin/global-mail-settings',
	exact: true,
};
